import orderBy from 'lodash/orderBy';
import uniq from 'lodash/uniq';
import { FlowType } from 'fable/flowEditor';
export var SystemVariableId;
(function (SystemVariableId) {
    SystemVariableId["Body"] = "body";
    SystemVariableId["CallerNumber"] = "caller_number";
    SystemVariableId["CCEmails"] = "cc_emails";
    SystemVariableId["Channel"] = "channel";
    SystemVariableId["CSID"] = "csid";
    SystemVariableId["Date"] = "date";
    SystemVariableId["DateRange"] = "date_range";
    SystemVariableId["Direction"] = "direction";
    SystemVariableId["FromEmail"] = "from_email";
    SystemVariableId["FromName"] = "from_name";
    SystemVariableId["Language"] = "language";
    SystemVariableId["ReceivingNumber"] = "receiving_number";
    SystemVariableId["Subject"] = "subject";
    SystemVariableId["SubjectOrBody"] = "subject_or_body";
    SystemVariableId["SpamProbability"] = "spam_probability";
    SystemVariableId["ToEmail"] = "to_email";
    SystemVariableId["EnduserExternalId"] = "enduser_external_id";
})(SystemVariableId || (SystemVariableId = {}));
export var SystemVariableType;
(function (SystemVariableType) {
    SystemVariableType["Input"] = "input";
    SystemVariableType["Scope"] = "scope";
    SystemVariableType["System"] = "system";
})(SystemVariableType || (SystemVariableType = {}));
export const FLOW_TYPE_CALL = 'FLOW_TYPE_CALL';
export const FLOW_TYPE_EMAIL = 'FLOW_TYPE_EMAIL';
const REGEX_VALID_NAME = /(:)/;
export const isValidVariableName = (name) => {
    return !REGEX_VALID_NAME.test(name);
};
export const getVariableNameErrorMessage = (name) => {
    const match = REGEX_VALID_NAME.exec(name);
    if (match === null) {
        return null;
    }
    return `Contains invalid characters "${match[1]}"`;
};
export function getSystemVariableString(id) {
    return `${SystemVariableType.System}:${id}`;
}
export const getAvailableFlowVariables = (props) => {
    const { scopeVars, flowType } = props;
    const flowCategories = [
        {
            label: 'Flow variables',
            items: orderBy(uniq(scopeVars.available).map((scopeVar) => ({
                name: `scope:${scopeVar}`,
                content: scopeVar,
            }), 'name')),
        },
    ];
    switch (flowType) {
        case FlowType.FLOW_TYPE_CALL:
            flowCategories.push({
                label: 'Conversation data',
                items: [
                    {
                        name: getSystemVariableString(SystemVariableId.CSID),
                        content: 'Conversation ID',
                    },
                    {
                        name: getSystemVariableString(SystemVariableId.CallerNumber),
                        content: 'Caller number',
                    },
                    {
                        name: getSystemVariableString(SystemVariableId.ReceivingNumber),
                        content: 'Receiving number',
                    },
                    {
                        name: getSystemVariableString(SystemVariableId.EnduserExternalId),
                        content: 'External ID',
                    },
                ],
            });
            break;
        case FlowType.FLOW_TYPE_EMAIL:
            flowCategories.push({
                label: 'Conversation data',
                items: [
                    {
                        name: getSystemVariableString(SystemVariableId.CSID),
                        content: 'Conversation ID',
                    },
                    {
                        name: getSystemVariableString(SystemVariableId.Channel),
                        content: 'Channel',
                    },
                    {
                        name: getSystemVariableString(SystemVariableId.Direction),
                        content: 'Direction',
                    },
                    {
                        name: getSystemVariableString(SystemVariableId.FromEmail),
                        content: 'From email',
                    },
                    {
                        name: getSystemVariableString(SystemVariableId.ToEmail),
                        content: 'To email',
                    },
                    {
                        name: getSystemVariableString(SystemVariableId.FromName),
                        content: 'From name',
                    },
                    {
                        name: getSystemVariableString(SystemVariableId.SubjectOrBody),
                        content: 'Subject or body',
                    },
                    {
                        name: getSystemVariableString(SystemVariableId.Subject),
                        content: 'Subject',
                    },
                    {
                        name: getSystemVariableString(SystemVariableId.Body),
                        content: 'Body',
                    },
                    {
                        name: getSystemVariableString(SystemVariableId.CCEmails),
                        content: 'CC emails',
                    },
                    {
                        name: getSystemVariableString(SystemVariableId.Language),
                        content: 'Language',
                    },
                    {
                        name: getSystemVariableString(SystemVariableId.EnduserExternalId),
                        content: 'External ID',
                    },
                ],
            });
            break;
        case FlowType.FLOW_TYPE_MESSENGER:
            flowCategories.push({
                label: 'Conversation data',
                items: [
                    {
                        name: getSystemVariableString(SystemVariableId.Language),
                        content: 'Language',
                    },
                    {
                        name: getSystemVariableString(SystemVariableId.FromEmail),
                        content: 'From email',
                    },
                    {
                        name: getSystemVariableString(SystemVariableId.FromName),
                        content: 'From name',
                    },
                    {
                        name: getSystemVariableString(SystemVariableId.CSID),
                        content: 'Conversation ID',
                    },
                    {
                        name: getSystemVariableString(SystemVariableId.EnduserExternalId),
                        content: 'External ID',
                    },
                ],
            });
            break;
    }
    return flowCategories;
};
